import { ILeanProductTile } from "@faire/web-api/indigofair/data/ILeanProductTile";
import { Span } from "@opentelemetry/api";
import React from "react";

interface IProductTileContext {
  recordAdImpression?: boolean;
  brand?: ILeanProductTile.IBrand | undefined;
  productTileSpan?: Span | null;
}

export interface IComposableComponents {
  productTile: ILeanProductTile;
  "data-test-id"?: string;
}

export const ProductTileContext = React.createContext<IProductTileContext>({});
